/**
 * Created by OLD on 23/11/2015.
 */
define('priceBillingTabView',[
  'module',  
  'marionette',
  'underscore',
  'app',
  'settings',
  'imageUtils',
  'template!billingTabTpl'
], function(
  module,
  Marionette,
  _,
  App,
  Settings,
  imageUtils,
  viewTpl
) {
  'use strict';

  var BillingTabView =  Marionette.LayoutView.extend({
    template: viewTpl,

    regions: {
      billingCodeTable: '.billing-price-table',
      billingDetailTable: '.billing-detail-table'
    },

    ui: {
      importBtn: '.billing-import',
      addNew: '.add-new-code-b',
      addNewPrice: '.add-new-pricelist-b',
      uploadPrices: '.js-upload-prices'
    },

    events: {
      'click @ui.addNewPrice' : 'onAddNewPrice',
      'click @ui.addNew' : 'onShowAddNewCodePopup',
      'change @ui.uploadPrices': 'onUploadPrices'
    },

    onShowAddNewCodePopup: function() {
      this.trigger('add-new-code:open');
    },

    onAddNewPrice: function() {
      this.trigger('add-new-pricelist:open');
    },

    onShow: function() {
      $.material.init();
    },

    onUploadPrices: function(e) {
      var that = this,
        target = e.target,
        fileInfo;

      if (e && e.target && e.target.files && e.target.files[0]) {
        fileInfo = imageUtils.getFileInfo(target, 0);

        if (fileInfo) {
          that.uploadCsv(fileInfo);
        }
      }
    },

    serializeData: function() {
      return {exportCsvUrl: Settings.url('compuzz2', 'v2/billingcodes/csv')};
    },

    uploadCsv: function (fileInfo) {
      this.ui.uploadPrices.val('');
      this.trigger('billingcodes:import-csv', fileInfo);
    }
  });

  module.exports = BillingTabView;
});
